module.exports = __webpack_public_path__ + "img/c_1.5465b5c1.png";